import i18n from 'i18n'
import * as React from "react"
import { SelectSeeker } from "ui-seeker/core"

const OPTIONS = [
    { label: 'January', i18nKey: 'common:month.january', value: '1' },
    { label: 'February', i18nKey: 'common:month.february', value: '2' },
    { label: 'March', i18nKey: 'common:month.march', value: '3' },
    { label: 'April', i18nKey: 'common:month.april', value: '4' },
    { label: 'May', i18nKey: 'common:month.may', value: '5' },
    { label: 'June', i18nKey: 'common:month.june', value: '6' },
    { label: 'July', i18nKey: 'common:month.july', value: '7' },
    { label: 'August', i18nKey: 'common:month.august', value: '8' },
    { label: 'September', i18nKey: 'common:month.september', value: '9' },
    { label: 'October', i18nKey: 'common:month.october', value: '10' },
    { label: 'November', i18nKey: 'common:month.november', value: '11' },
    { label: 'December', i18nKey: 'common:month.december', value: '12' },
]

export default function SelectMonth({ ...props }) {

    const myProps = {
        placeholder: i18n.t('common:filters.selectMonth'),
        label: i18n.t('common:filters.monthRequired'),
        firstSelect: true,
        isClearable: true,
        options: OPTIONS.map(o => ({ ...o, label: i18n.t(o.i18nKey, { defaultValue: o.label }) })),
        icon: { icon: 'calendar-day' },
        isMulti: true,
        ...props
    }

    return <SelectSeeker {...myProps} />
}
